// MagicWand.js
import React from 'react';

const MagicWand = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className="magic-wand-icon"
  >
    <path d="M15 4V2"></path>
    <path d="M15 16v-2"></path>
    <path d="M8 9h2"></path>
    <path d="M20 9h2"></path>
    <path d="M17.8 11.8L19 13"></path>
    <path d="M15 9h0"></path>
    <path d="M17.8 6.2L19 5"></path>
    <path d="m3 21 9-9"></path>
    <path d="M12.2 6.2 11 5"></path>
    <path d="m12.2 11.8-1.4 1.4"></path>
  </svg>
);

export default MagicWand;